import axios from "./axios";

const Participants = {
  /**
   * Fetches all Participants's
   *
   * @return {array} Array of Participants's
   */
  async get(eventId) {
    try {
      const res = await axios.get(`/participants?eventId=${eventId}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: [],
      };
    }
  },

  /**
   * Fetches the participant status by id and event id
   *
   * @return {array} Array of Participants's
   */
  async getStatus(userId, eventId) {
    try {
      const res = await axios.get("/participants/status/byUserEventId", {
        params: {
          userId: userId,
          eventId: eventId,
        },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: false,
      };
    }
  },

  /**
   * Fetches one Participants by it's ID
   *
   * @param {string} id ID of the Participants
   * @return {object} Participants with the corresponding ID
   */
  async getById(participantsId) {
    try {
      const res = await axios.get("/participants/" + participantsId);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Creates one Participants
   *
   * @param {object} participants Object with the creation data
   * @return {object} Newly created Participants
   */
  async create(participants) {
    let reqBody = { ...participants };
    try {
      const res = await axios.post("/participants", reqBody);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Creates participant without email/PDF - for manual admin adds
   *
   * @param {object} participants Object with the creation data
   * @return {object} Newly created Participants
   */
  async createSimple(participants) {
    let reqBody = { ...participants };
    try {
      const res = await axios.post("/participants/simple", reqBody);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Updates a Participant by ID
   *
   * @param {string} participantId ID of the Participant
   * @param {object} data Update data
   * @return {object} Updated Participant
   */
  async update(participantId, data) {
    try {
      const res = await axios.patch("/participants/" + participantId, data);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Deletes Participants by ID
   *
   * @param {string} participantsId ID of the Participants to be deleted
   * @return {string} ID of the deleted Participants
   */
  async delete(participantsId) {
    try {
      await axios.delete("/participants/" + participantsId);
      return {
        ok: true,
        data: {
          id: participantsId,
        },
      };
    } catch (error) {
      return {
        ok: false,
        data: {
          id: participantsId,
        },
      };
    }
  },

  /**
   * Cancel participation by userId and eventId
   *
   * @param {string} userId ID of the user
   * @param {string} eventId ID of the event
   * @return {object} Result
   */
  async cancelParticipation(userId, eventId) {
    try {
      const res = await axios.patch("/participants/cancelParticipation", null, {
        params: { userId, eventId },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return { ok: false, data: {} };
    }
  },
  /**
   * Fetches one Participant number of participations on event as guest
   *
   * @param {string} id ID of the Participant
   * @return {number} number of times participated
   */
  async getNoOfParticipationsAsGuest(userId) {
    try {
      const res = await axios.get(
        "/participants/numberOf/Participations/userId",
        {
          params: {
            userId,
          },
        }
      );
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },
  /**
   * Fetches one Participants presence
   *
   * @param {string} id ID of the user
   * @return {object} number of participantions
   */
  async getUserParticipantions(userId) {
    try {
      const res = await axios.get(
        `/participants/countPresence/userId?userId=${userId}`
      );
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },
};

export default Participants;
